import 'swiper/css';
import {Swiper, Keyboard, A11y} from 'swiper';

export default () => {
  const init = () => {
    if (!customElements.get("merch-slider")) {
      customElements.define("merch-slider", MerchSlider);
    }
  };

  class MerchSlider extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = this.querySelector(".merch-highlight");
    }

    initializeSwiper() {
      window.addEventListener('DOMContentLoaded', () => {
        const element = this.querySelector(".merch-highlight")
        element.querySelectorAll('.swiper-slide').forEach((el) => {
          if (el.classList.contains('swiper-slide-active')) {
            el.setAttribute('aria-hidden', 'false');
          } else {
            el.setAttribute('aria-hidden', 'true');
          }
        })
      })

      if (this.mainSlider) {
        // eslint-disable-next-line
        new Swiper(this.mainSlider, {
          loop: false,
          slidesPerView: 4,
          spaceBetween:16,
          freeMode: true,
          modules: [ Keyboard, A11y ],
          a11y: { enabled: true },
          keyboard: { enabled: true, onlyInViewport: true },
          breakpoints: {
            300: {
              slidesPerView: 1.1,
            },
            500: {
              slidesPerView: 1.5,
            },
            768: {
              slidesPerView: 3.1
            },
            1024: {
              slidesPerView: 4,
            }
          }
        });
      }
    }

    connectedCallback() {
      this.initializeSwiper();
    }
  }

  init();
}
